import { Component, OnInit } from '@angular/core';
import { MessageService } from '@app/shared/services/common/message.service';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { CommonService } from '@app/shared/services/common/common.service';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';
import { DashboardService } from '@app/shared/services/dashboard/dashboard.service';
import {IResStoreAdminChartInterface} from '@app/shared/components/line-chart/IResStoreAdminChart.interface';
import { Chart, registerables } from 'chart.js'; // Import registerables
  

@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.css']
})
export class LineChartComponent implements OnInit {

  revenueChartForm !: FormGroup;
  storeList: any[] = [];
  // ------------------------------- REVENUE lineChart ------------------------------------------------
  public revenuelineChartData: Array<any> = [
    { data: [], label: '' }
  ];
  displayRevenueLineChart = false;
  public revenuelineChartLabels: Array<any> = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  public revenuelineChartOptions: any = {
    responsive: true,
    tooltips: {
      callbacks: {
        label: function (tooltipItems: any, data: any) {
          return data.datasets[tooltipItems.datasetIndex].label + ': ' + '$' + tooltipItems.yLabel;
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        min: 0,
        max: 200,
        ticks: {
          stepSize: 40,
          callback: (value: any) => '$' + value,
        },
      },
    }
  };

  public revenuelineChartColors: Array<any> = [
    { // grey
      backgroundColor: 'rgba(148,159,177,0.2)',
      borderColor: 'rgba(148,159,177,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    }
  ];
  public revenuelineChartLegend = true;
  public revenuelineChartType = 'line';


  // ------------------------------- Orders lineChart ------------------------------------------------
  public orderlineChartData: Array<any> = [
    { data: [], label: '' }
  ];
  public orderlineChartLabels: Array<any> = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  public orderlineChartOptions: any = {
    responsive: true
    ,
    scales: {
      y: {
        beginAtZero: true,
        min: 0,
        max: 500,
        ticks: {
          stepSize: 100,
          callback: (value: any) => value,
        },
      },
    }
  };

  public orderlineChartColors: Array<any> = [
    { // orange
      backgroundColor: 'rgba(252,221,207,0.2)',
      borderColor: 'rgba(247,98,29,1)',
      pointBackgroundColor: 'rgba(247,98,29,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(247,98,29,1)'
    },
    { // red
      backgroundColor: 'rgba(252,181,181,0.2)',
      borderColor: 'rgba(188, 0, 0, 1)',
      pointBackgroundColor: 'rgba(188, 0, 0, 1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgb(152, 179, 236)'
    },
    { // green
      backgroundColor: 'rgba(206,242,188,0.2)',
      borderColor: 'rgba(35, 89, 8, 1)',
      pointBackgroundColor: 'rgba(35, 89, 8, 1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(35, 89, 8, 1)'
    }
  ];
  public orderlineChartLegend = true;
  public orderlineChartType = 'line';
  userRole: any;

  constructor(private messageService: MessageService, private formBuilder: FormBuilder,  private loader: LoaderService, private commonService: CommonService,
    private errorhandlerService: ErrorhandlerService, private dashboardService: DashboardService) {
    this.revenueChartForm = this.formBuilder.group({
      StoreId: new FormControl('0')
    });
    Chart.register(...registerables); // Register all Chart.js components
  }

  ngOnInit() {
    this.userRole = localStorage.getItem('role');
    this.fn_getStoreList();
    this.messageService.getSuperAdminChartData().subscribe(res => {
      this.revenuelineChartData = [];

      this.displayRevenueLineChart = true;
      this.revenuelineChartData.push(res.chartData);
    });

    this.messageService.getStoreAdminChartData().subscribe((res: any) => {
      this.newSettingForChart(res.chartData);
      this.displayRevenueLineChart = true;
      this.revenuelineChartData = [];
      this.revenuelineChartData.push(res.chartData.storeAdDashboardRevenueChartData);

      this.orderlineChartData = [];
      res.chartData.ordersChartData.forEach((obj: any) => {
        this.orderlineChartData.push(obj);
      });
    });
  }

  newSettingForChart(data: IResStoreAdminChartInterface) {
    const max = Math.max.apply(Math, data.storeAdDashboardRevenueChartData.data);
    this.revenuelineChartOptions.scales.y.max = max * 2;
    this.revenuelineChartOptions.scales.y.ticks.stepSize =  max % 3 !== 0 ? Number((max / 3).toFixed(1)) : max / 3;
    let maxOrders = 0;
    data.ordersChartData.forEach(x => {
      if (Math.max.apply(Math, x.data) > maxOrders) {
        maxOrders = Math.max.apply(Math, x.data);
      }
    });
    this.orderlineChartOptions.scales.y.max = maxOrders * 2;
    this.orderlineChartOptions.tension = 0.4;
    this.orderlineChartOptions.scales.y.ticks.stepSize = maxOrders % 3 !== 0 ? Number((maxOrders / 3).toFixed(1)) : maxOrders / 3;
  }

  // events
  public revenuechartClicked(e: any): void {
 
  }

  public revenuechartHovered(e: any): void {
   
  }

    /** Function to get store list */
    fn_getStoreList() {
      this.loader.show();
      this.commonService.getStoreListDashboard('', 0, 0, false, 0,false).subscribe(
        (res: any) => {
          if (
            res.StatusCode === 200 &&
            res.Data.ResponseData != null &&
            res.Data.ResponseData.length > 0
          ) {
            this.storeList = res.Data.ResponseData;
            this.loader.hide();
          } else if (res.StatusCode === 204 || res.StatusCode === 404) {
            this.loader.hide();
          }
        },
        err => {
          this.loader.hide();
          // this.notificationService.error('An error occured', 'Error');
          this.errorhandlerService.handleError(err);
        }
      );
    }

    /** Func to get RevnueChartData per store */
    fn_GetSuperAdminRevnueChartData(event: any) {
      this.dashboardService.GetSuperAdminRevnueChartData(event).subscribe(
        (res: any) => {
          if (res.StatusCode === 200) {
            this.revenuelineChartData = [];
            this.revenuelineChartData.push(res.Data.ResponseData);
            this.loader.hide();
          } else if (res.StatusCode === 500) {
            this.loader.hide();
          }
        },
        (error: any) => {
          this.loader.hide();
          // this.errorhandlerService.handleError(error);
          this.errorhandlerService.handleError(error);
        }
      );
    }
}
